<template>
  <div id="app-container">
    <NavigationBar />

    <main class="main-content">
      <router-view />
    </main>

    </div>
</template>

<script setup>
import NavigationBar from './components/NavigationBar.vue';
// computedやshowNavBarは不要になったので削除
</script>

<style>
/* アプリケーション全体のスタイル */
body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  background-color: #f4f6f9;
}

#app-container {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #333;
}

/* ★★★ 追加 ★★★ */
.main-content {
  padding-top: 60px; /* ヘッダーの高さ分だけ余白を設ける */
}
</style>